import { Box, BoxProps, Icon, IconButton, ModalDialog, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'

interface ScanUserModalProps {
  show: boolean
  onDismiss: any
  onPress: any
}
export const ScanUserModal = ({ show, onDismiss, onPress }: ScanUserModalProps) => {
  return (
    <ModalDialog {...{ show, onDismiss }} type="Bottom">
      <Box {...styles.container}>
        <Box {...styles.header}>
          <TextNew {...styles.title}>Scan Using</TextNew>
          <IconButton id="CLEAR" size={24} onPress={onDismiss} color={'GRAY_75' as any} />
        </Box>
        <Box marginVertical={24} flexDirection={'row'}>
          <Box {...styles.tile} onPress={() => onPress('FINGER_PRINT')}>
            <Icon id="FINGERPRINT" size={24} color={'PRIMARY_STORNG'} />
            <SpacerNew size={4} />
            <TextNew {...styles.tileText}> FingerPrint</TextNew>
          </Box>
          <Box {...styles.tile} onPress={() => onPress('FACE')}>
            <Icon id="CAMERA" size={24} color={'PRIMARY_STORNG'} />
            <SpacerNew size={4} />
            <TextNew {...styles.tileText}> Face</TextNew>
          </Box>
        </Box>
      </Box>
    </ModalDialog>
  )
}

const styles = {
  container: {
    pv: 16,
    ph: 16,
  } as BoxProps,
  title: {
    fontSize: 16,
    fontFamily: 'jioType-medium',
    color: '#757575' as any,
  } as TextNewProps,
  tileText: {
    fontSize: 12,
    color: 'PRIMARY_STORNG',
  } as TextNewProps,
  header: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  } as BoxProps,
  tile: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderRadius: '4',
    p: 8,
    mr: 16,
    width: 100,
    height: 100,
    borderColor: 'PRIMARY_STORNG',
  } as BoxProps,
}
